import React, {useEffect} from "react";
import {Redirect, Route, Router, Switch} from "react-router-dom";
import {useSelector} from "react-redux";

import {AppLinks} from '../../environment/app-links'
import {AppState, apphistory} from "../../store";
import ErrorPage from "../ErrorPage/ErrorPage";
import WaitingScreen from "../WaitingScreens/WaitingScreenPage";
import BMVerifyPage from "../BankVerification/BankVerificationPage";
import BmWaitingScreen from "../WaitingScreens/BMWaitingPage/BMWaitingPage";
import BankVerificationSuccessPage from "../BankVerificationSuccess/BankVerificationSuccessPage";
import FailPage from "../FailPage/FailPage";
import StartPage from '../StartPage/StartPage';
import ManualVerificationPage from '../ManualVerificationPage/ManualVerificationPage'
import ContractSigningPage from '../ContractSigningPage/ContractSigningPage'
import SessionEndPage from '../SessionEndPage/SessionEndPage'
import BasicInfoForm from '../Forms/BasicInfoForm'
import ComebackPage from '../ComebackPage/ComebackPage'
import ExtendedInfoForm from '../Forms/ExtendedInfoForms'
import AddressInfoForm from '../Forms/AddressInfoForm'
import IncomeInfoForm from '../Forms/IncomeTypeForm'
import AffiliatePage from '../AffiliatePage/AffiliatePage'
import { hasRecognizedAffiliatePartnerParams } from '../AffiliatePage/affiliatePartnersData'
import ClientPeselReservedPage from '../ClientPeselReservedPage/ClientPeselReservedPage'
import ClientChoiceVerificationPage from "../ClientChoiceVerificationPage/ClientChoiceVerificationPage";
import Footer from "../../components/footer/footer";
import PredefinedOfferPage from '../PredefinedOfferPage/PredefinedOfferPage'
import CustomClientOfferPage from '../CustomClientOfferPage/CustomClientOfferPage'
import ContractDonePage from '../ContractDonePage/ContractDonePage'
import VideoVerificationStartPage from '../VideoVerificationPages/VideoVerificationStartPage/VideoVerificationStartPage'
import MObywatelIdentityPage from '../MObywatelIdentityPage/MObywatelIdentityPage'
import VideoVerificationBackFromPartnerPage from '../VideoVerificationPages/VideoVerificationBackFromPartnerPage'
import ManualVerificationPageHubRedirection from '../ManualVerificationPage/ManualVerificationPageHubRedirection'
import UserOfflinePage from '../UserOfflinePage/UserOfflinePage'
import ManualVerificationClientPeselReservedPage
    from '../ManualVerificationPage/ManualVerificationClientPeselReservedPage'
import useAppRootLogic, {CurrentFormUrlPathContext} from './hooks/useAppRootLogic'
import Sidebar from '../../components/organisms/Sidebar/Sidebar'
import {AppSnackbarProvider} from "../../components/molecules/AppSnackbar/AppSnackbarProvider";
import OfferWaitingPage from '../WaitingScreens/OfferWaitingPage/OfferWaitingPage'


import "./AppRootStyles.scss";


// NA POTRZEBY KONTOMATIK ORAZ BIK CFD
declare global {
  interface Window {
    embedKontomatik: (a: any) => void
    removeKontomatik: () => void

    ptadx: {
      ptinitiate: Function;
      ptvalidate: Function;
    }
  }
}



const AppRoot = () => {
    const IS_CUSTOM_OFFER_ONLY = useSelector((state: AppState) => state.offertState.isCustomOfferOnly)
    const isMetaPixelEnabled = useSelector((state: AppState) => state.lenConfigState?.globalConfig?.metaPixelEnabled === true)
    useEffect(() => {
      if (!isMetaPixelEnabled) {
        return;
      }

      if (document.querySelector('script[data-meta-pixel="true"]')) {
        return;
      }

      const pixelScript = document.createElement("script");
      pixelScript.src = "/meta-pixel.js";
      pixelScript.async = true;
      pixelScript.dataset.metaPixel = "true";
      document.head.appendChild(pixelScript);
    }, [isMetaPixelEnabled]);

    const {
      currentUrlFormPath,
      setCurrentUrlFormPath,
    } = useAppRootLogic()
    return (
        <div className="app-container">
          <div className="app-card">
              <Sidebar/>
              {
                <CurrentFormUrlPathContext.Provider value={{currentUrlFormPath, setCurrentUrlFormPath}}>
                  <AppSnackbarProvider>
                    <Router history={apphistory}>
                      <Switch>
                          <Route path={AppLinks.start} exact component={StartPage}/>
                          <Route path={AppLinks.return} exact component={ComebackPage}/>
                          <Route path={AppLinks.affiliate} exact component={AffiliatePage}/>
                          <Route path={AppLinks.success} exact component={BankVerificationSuccessPage}/>
                          <Route path={AppLinks.bmWaiting} exact component={BmWaitingScreen}/>
                          <Route path={AppLinks.offerWaiting} exact component={OfferWaitingPage}/>
                          <Route path={AppLinks.waiting} exact component={WaitingScreen}/>
                          <Route path={AppLinks.error} exact component={ErrorPage}/>
                          <Route path={AppLinks.fail} exact component={FailPage}/>
                          <Route path={AppLinks.manualVerification} exact
                                 render={() => <ManualVerificationPage
                                 isManualVerificationFailPage={false}/>}/>
                          <Route path={AppLinks.manualVerificationFailPage} exact
                                 render={() => <ManualVerificationPage
                                 isManualVerificationFailPage={true}/>}/>
                          <Route path={AppLinks.manualVerificationHubRedirection} exact
                                 render={() => <ManualVerificationPageHubRedirection/>}/>
                          <Route path={AppLinks.contractSigning} exact component={ContractSigningPage}/>
                          <Route path={AppLinks.bmverify} exact component={BMVerifyPage}/>
                          <Route path={AppLinks.kontomatikSignInRedirectionReturnError} exact component={BMVerifyPage}/>
                          <Route path={AppLinks.offert} exact render={() => IS_CUSTOM_OFFER_ONLY
                              ? <Redirect to={AppLinks.customOffer}/>
                              : <PredefinedOfferPage/>}/>
                          <Route path={AppLinks.customOffer} exact component={CustomClientOfferPage}/>
                          <Route path={AppLinks.houston} exact component={UserOfflinePage}/>
                          <Route path={AppLinks.sessionEnd} exact component={SessionEndPage}/>
                          <Route path={AppLinks.clientPeselReservedPage} exact
                                 component={ClientPeselReservedPage}/>
                          <Route path={AppLinks.clientChoiceManualVerification} exact
                                 component={ClientChoiceVerificationPage}/>
                          <Route path={AppLinks.contractDone} exact component={ContractDonePage}/>
                          <Route path={AppLinks.videoVerificationStartManualVerificationPage} exact
                                 component={VideoVerificationStartPage}/>
                          <Route path={AppLinks.videoVerificationBackFromPartner} exact
                                 component={VideoVerificationBackFromPartnerPage}/>
                          <Route path={AppLinks.manualVerificationMObywatelIdentityPage} exact
                                 component={MObywatelIdentityPage}/>
                          <Route path={AppLinks.manualVerificationclientPeselReservedPage} exact
                                 component={ManualVerificationClientPeselReservedPage}/>
                          <Route path={AppLinks.basicInfoForm} exact component={BasicInfoForm}/>
                          <Route path={AppLinks.extendedInfoForm} exact component={ExtendedInfoForm}/>
                          <Route path={AppLinks.addressInfoForm} exact component={AddressInfoForm}/>
                          <Route path={AppLinks.incomeInfoForm} exact component={IncomeInfoForm}/>
                          <Route
                              path="*"
                              render={({ location }) => {
                                  if (
                                      location.pathname === AppLinks.default &&
                                      hasRecognizedAffiliatePartnerParams(location.search)
                                  ) {
                                      return <AffiliatePage />
                                  }

                                  const queryParams = new URLSearchParams(location.search)
                                  const shouldPreserveQuery = queryParams.get("source") === "fb"
                                  const redirectTarget = shouldPreserveQuery
                                      ? `${AppLinks.basicInfoForm}${location.search ?? ""}${location.hash ?? ""}`
                                      : AppLinks.basicInfoForm

                                  return <Redirect to={redirectTarget}/>
                              }}

                          /> {/* Każda inna ścieżka */}
                        </Switch>
                      </Router>
                  </AppSnackbarProvider>
                </CurrentFormUrlPathContext.Provider>
              }
          </div>
          <Footer/>
        </div>
    )
}

export default AppRoot;